import request from "../utils/shuleRequest/request";


const service = {
    getPartner: (param)=>request('/hospital/v1/card/partnerinstitute/page',param,'get'),
    getPartnerList: (param)=>request('/hospital/v1/card/partnerinstitute/list',param,'get'),
    getPartnerById: (id)=>request('/hospital/v1/card/partnerinstitute/'+id,{},'get'),
    createPartner:(param)=>request('/hospital/v1/card/partnerinstitute',param,'post'),
    deletePartner:(ids)=>request('/hospital/v1/card/partnerinstitute/'+ids,{},'delete'),
    updatePartner:(id,param)=>request('/hospital/v1/card/partnerinstitute/'+id,param,'put'),
    // 获取七牛token
    getQiniuToken:() =>request('/hospital/v1/systemctl/fileinfo/qiniu/token',{},'get'),
    /***************************************************会员卡 ***************************************/
    createCard:(param) => request('/hospital/v1/card/cardinfo',param,'post'),
    batchCreateCard:(param) => request('/hospital/v1/card/cardinfo/batch',param,'post'),
    getCard:(param)=>request('/hospital/v1/card/cardinfo/page',param,'get'),
    // 根据批次号派发会员卡
    pendingFirstBatchid:(param)=>request('/hospital/v1/card/cardinfo/status/pending/first/batchid',param,'PUT'),
    pendingFirstCardnos:(param)=>request('/hospital/v1/card/cardinfo/status/pending/first/cardnos',param,'PUT'),
    // 生成二维码
    GenerateQrcode:(param)=>request('/hospital/v1/card/cardinfo/qrcode',param,'PUT'),
    // 按卡号回收会员卡
    retrieveMemberByCodeNos:(param)=>request('/hospital/v1/card/cardinfo/status/created/multi',param,'PUT'),
    // 按批次号回收会员卡
    retrieveMemberByBatchid:(param)=>request('/hospital/v1/card/cardinfo/status/created/batchid',param,'PUT'),
    // 查询可被领取的会员卡数量
    getPendingCount:(param) =>request('/hospital/v1/card/cardinfo/status/createdpending/count',param,'get'),
    // 根据卡号删除会员卡信息
    deleteCardByNos:(ids)=>request('/hospital/v1/card/cardinfo/'+ids,{},'delete'),
    // 获取领取记录
    getBelongingRecord:(param) =>request('/hospital/v1/card/belongingrecord/list',param,'get'),
    // 查询帖子
    getPostsRecord:(param) =>request('/hospital/v1/posts/page',param,'get'),
    // 删除帖子
    deletePostsByNos:(id)=>request('/hospital/v1/posts/'+id,{},'delete'),
    // 激活记录
    getCardActivatePage:(param) =>request('/hospital/v1/card/cardactivate/page',param,'get'),
    // 发卡记录
    getBelongingRecordPage:(param) =>request('/hospital/v1/card/belongingrecord/page',param,'get')





    // updateCard:(id,param)=>request('/hospital/v1/card/cardinfo//'+id,param,'put'),
}


export default{
    ...service
}



// WEBPACK FOOTER //
// ./src/api/shule.js